import API from './axios.js';

// Timeline
export const addUpdateTimelineRemark = (payload) => API.post('timeline', payload);
export const getTimelineRemarksByCourtRef = (courtRef) => API.get(`timeline/timeline-by-court-ref/${courtRef}`);
export const deleteTimelineRemark = (remarkId) => API.delete(`timeline/${remarkId}`);